import { FETCHOPTIONS, JSON_CONTENTTYPE, JS_CONTENTTYPE, PROGRESSEVENT_TYPES } from "../scripts/api/constants";

import notifier from "./helpers/airbrake";

function dispatchProgressEvent(type, contentLength = 0) {
  const progressEvent = new ProgressEvent(type, {
    lengthComputable: !!contentLength,
    loaded: contentLength,
    total: contentLength
  });

  document.body.dispatchEvent(progressEvent);
}

function ErrorObject(args = {}) {
  return Object.assign({
    timestamp: Date.now()
  }, args);
}

async function fetcher(url, fetchOptions = {}) {
  const { abortController, headers = {}, timeout, ...rest } = fetchOptions;
  const options = { ...FETCHOPTIONS, ...rest };
  const headerOptions = { ...FETCHOPTIONS.headers, ...headers };

  options.headers = headerOptions;

  let controller = abortController;
  let response;

  dispatchProgressEvent(PROGRESSEVENT_TYPES.LOADSTART);

  if (controller || timeout) {
    controller = controller || new AbortController();
    options.signal = controller.signal;

    if (timeout) {
      setTimeout(() => {
        controller.abort();
        dispatchProgressEvent(PROGRESSEVENT_TYPES.TIMEOUT);
      }, timeout);
    }
  }

  try {
    response = await fetch(url, options);

    if (!response.ok) {
      throw new ErrorObject({ message: `${response.status} (${response.statusText.trim()})`, url });
    }

    const length = parseInt(response.headers.get("Content-Length"), 10) || 0;

    dispatchProgressEvent(PROGRESSEVENT_TYPES.LOAD, length);

    return response;
  } catch (e) {
    if (e.name !== "AbortError") {
      dispatchProgressEvent(PROGRESSEVENT_TYPES.ERROR);
      const err = new ErrorObject({ ...e, url });

      notifier.notify({ ...err, message: `${e.message} ${url}` });

      throw err;
    }

    dispatchProgressEvent(PROGRESSEVENT_TYPES.ABORT);

    return null;
  }
}

async function json(url, options = { warn: false }) {
  const { abortController, signal, timeout } = options;

  try {
    const response = await fetcher(url, {
      abortController: abortController || new AbortController(),
      headers: {
        Accept: `${JSON_CONTENTTYPE},${JS_CONTENTTYPE};q=0.8,*/*;q=0.01`,
        "Content-Type": JSON_CONTENTTYPE
      },
      signal,
      timeout
    });

    return await response.json();
  } catch (e) {
    if (options.warn) {
      // eslint-disable-next-line
      console.warn(`Data error: ${e.message}`, e.url);
    }

    throw e;
  }
}

export {
  dispatchProgressEvent,
  fetcher,
  json
};



// WEBPACK FOOTER //
// ./shared/fetcher.js